export const baseURL = "https://casino.digicean.com/";
// export const baseURL = "http://192.168.1.51:6009/";
export const adminBaseURL = "https://tingle.digicean.com/";
export const key = "?TZ-ul`^Rr^-$vh*SEna{XM&X0+,}y";